import { createComponent } from '../lib';
import { VmControlSpacer } from '@vime/core';
import { define } from '../lib';
define('vm-control-spacer', VmControlSpacer);
;
export default createComponent('vm-control-spacer', new Set([]));
//# sourceMappingURL=ControlSpacer.jsx.map